import { render, staticRenderFns } from "./FirstCard.vue?vue&type=template&id=16c3b7ff&scoped=true&"
import script from "./FirstCard.vue?vue&type=script&lang=ts&"
export * from "./FirstCard.vue?vue&type=script&lang=ts&"
import style0 from "./FirstCard.vue?vue&type=style&index=0&id=16c3b7ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3b7ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VImg})
